import React from 'react';
import classnames from 'classnames';
import { ButtonNext } from 'pure-react-carousel';
import { MultiMediaViewerConsumer } from '../MultimediaViewer';
import {
  IMAGE_VIEWER_CONTROLS_HIDDEN_CLASS,
  NEXT,
} from '../../types/constants';
import { calculateCurrentSlide } from './utils';

const NextButton = React.forwardRef(
  (
    { carouselStore, controlsHidden, multipleMediaAssetsExist, onClick },
    ref
  ) => {
    const classes = classnames(
      'imageviewer-next',
      controlsHidden ? IMAGE_VIEWER_CONTROLS_HIDDEN_CLASS : ''
    );
    if (!multipleMediaAssetsExist) return null;

    return (
      <div className={classes} onClick={onClick}>
        <MultiMediaViewerConsumer>
          {({ updateCurrentSlide, currentSlide }) => (
            <ButtonNext
              className="no-button-styling"
              onClick={() => updateCurrentSlide(calculateCurrentSlide(carouselStore, NEXT))}
            >
              <span className="icon prism-icon-chevron-right-light" />
            </ButtonNext>
          )}
        </MultiMediaViewerConsumer>
      </div>
    );
  }
);

export default NextButton;
